import React from 'react'
import { holdReasonLabel } from '../../utils/orderHoldReasons'
import PauseIcon from './PauseIcon'

function StatusBadge({ status, type = 'default' }) {
  const getClass = () => {
    switch (type) {
      case 'success':
      case 'fulfilled':
      case 'paid':
      case 'ready':
        return 'badge-success'
      case 'warning':
      case 'pending':
      case 'partial':
      case 'flagged':
        return 'badge-warning'
      case 'error':
      case 'cancelled':
      case 'refunded':
      case 'unpriced':
        return 'badge-error'
      case 'info':
      case 'unfulfilled':
        return 'badge-info'
      case 'purple':
      case 'no-category':
        return 'badge-purple'
      default:
        return 'badge-neutral'
    }
  }

  return (
    <span className={`badge ${getClass()}`}>
      {status}
    </span>
  )
}

// Helper to get status badge for drafts
export function DraftStatusBadge({ draft }) {
  if (!draft.product_type) {
    return <StatusBadge status="No Category" type="purple" />
  }
  if (draft.isFlagged) {
    return <StatusBadge status="Needs Review" type="warning" />
  }
  if (draft.isUnpriced) {
    return <StatusBadge status="Unpriced" type="error" />
  }
  if (draft.sellPrice > 0) {
    return <StatusBadge status="Ready" type="success" />
  }
  return null
}

// Helper to get fulfillment status badge
function formatStatusLabel(status) {
  return status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

export function FulfillmentBadge({ status }) {
  const rawStatus = status || 'unfulfilled'
  let type = 'info'
  if (['fulfilled', 'shipped', 'picked_up', 'received'].includes(rawStatus)) type = 'success'
  else if (rawStatus === 'partial') type = 'warning'
  else if (['refunded', 'cancelled'].includes(rawStatus)) type = 'error'
  return <StatusBadge status={formatStatusLabel(rawStatus)} type={type} />
}

// Helper to get financial status badge
export function FinancialBadge({ status }) {
  let type = 'info'
  if (status === 'paid') type = 'success'
  else if (status === 'pending') type = 'warning'
  else if (status === 'refunded') type = 'default'

  return <StatusBadge status={status?.charAt(0).toUpperCase() + status?.slice(1) || 'Unknown'} type={type} />
}

// The amber badge on an order that has an open hold. `hold` is the order's on_hold.
export function HoldBadge({ hold }) {
  if (!hold) return null
  return (
    <span className="badge badge-warning" style={{ whiteSpace: 'nowrap' }} title={`On hold: ${holdReasonLabel(hold.reason)}`}>
      <PauseIcon size={10} /> On hold
    </span>
  )
}

export default StatusBadge
